<template>
  <el-dialog
    title="提醒规则"
    width="50%"
    :visible.sync="show"
    :before-close="handleClose"
    :close-on-click-modal="false"
    :append-to-body="true"
  >
    <table class="form-table" cellspacing="0" cellpadding="0" border="0">
      <tbody>
        <!-- <tr>
          <th width="120px">
            <eco-radio
              v-model="triggerConf.rdoTimeType"
              :options="[{ key: '1', value: '一次:' }]"
            />
          </th>x
          <td>
            <eco-date
              v-model="triggerConf.sampleDate"
              :validate="{
                required: triggerConf.rdoTimeType != '1' ? false : true
              }"
            />
          </td>
        </tr> -->
        <tr>
          <th width="120px">
            <eco-radio
              v-model="triggerConf.rdoTimeType"
              :options="[{ key: '2', value: '每天:' }]"
            />
          </th>
          <td>
            <el-time-picker
              :disabled="triggerConf.rdoTimeType != '2'"
              v-model="triggerConf.txtDay"
              placeholder="选择时间"
              value-format="HH:mm"
              format="HH:mm"
            ></el-time-picker>
          </td>
        </tr>
        <tr>
          <th width="120px">
            <eco-radio
              v-model="triggerConf.rdoTimeType"
              :options="[{ key: '4', value: '每周:' }]"
            />
          </th>
          <td>
            <eco-checkbox
              :disabled="triggerConf.rdoTimeType != '4'"
              v-model="triggerConf.chkWeek"
              :options="chkWeek"
              :validate="{
                required: triggerConf.rdoTimeType != '4' ? false : true
              }"
            />
            <el-time-picker
              :disabled="triggerConf.rdoTimeType != '4'"
              v-model="triggerConf.txtWeek"
              placeholder="选择时间"
              value-format="HH:mm"
              format="HH:mm"
              :validate="{
                required: triggerConf.rdoTimeType != '4' ? false : true
              }"
            ></el-time-picker>
            <span> 符合条件当天提醒一次：</span>
            <el-radio-group
              v-model="triggerConf.weekReminder"
              :disabled="triggerConf.rdoTimeType != '4'"
            >
              <el-radio :label="1">是</el-radio>
              <el-radio :label="0">否</el-radio>
            </el-radio-group>
          </td>
        </tr>
        <tr>
          <th width="120px">
            <eco-radio
              v-model="triggerConf.rdoTimeType"
              :options="[{ key: '5', value: '每月:' }]"
            />
          </th>
          <td>
            <eco-checkbox
              :disabled="triggerConf.rdoTimeType != '5'"
              v-model="triggerConf.chkMons"
              :options="chkMons"
              :validate="{
                required: triggerConf.rdoTimeType != '5' ? false : true
              }"
            />
            <el-time-picker
              :disabled="triggerConf.rdoTimeType != '5'"
              v-model="triggerConf.txtMon"
              placeholder="选择时间"
              value-format="HH:mm"
              format="HH:mm"
            ></el-time-picker>
            <span> 符合条件当天提醒一次：</span>
            <el-radio-group
              v-model="triggerConf.monReminder"
              :disabled="triggerConf.rdoTimeType != '5'"
            >
              <el-radio :label="1">是</el-radio>
              <el-radio :label="0">否</el-radio>
            </el-radio-group>
          </td>
        </tr>
      </tbody>
    </table>
    <div slot="footer" class="dialog-footer">
      <el-button type="primary" @click="handleSave">确 定</el-button>
      <el-button @click="handleClose">取 消</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  props: {
    show: {
      type: Boolean,
      default: () => false
    },
    time: {
      type: String
    }
  },
  watch: {
    time: {
      deep: true,
      immediate: true,
      handler(newVal) {
        if (newVal && newVal != "") {
          const a = JSON.parse(newVal);
          const b = this.triggerConf;
          const newObject = {};
          Object.assign(newObject, a, b);
          this.triggerConf = newObject;
        }
      }
    }
  },
  data() {
    return {
      triggerConf: {},
      chkWeek: [
        { key: "1", value: "星期一" },
        { key: "2", value: "星期二" },
        { key: "3", value: "星期三" },
        { key: "4", value: "星期四" },
        { key: "5", value: "星期五" },
        { key: "6", value: "星期六" },
        { key: "7", value: "星期天" }
      ],
      chkMons: []
    };
  },
  created() {
    for (let index = 1; index < 32; index++) {
      //this.chkMons.push({ key: '"'+index+'"', value: index});
      this.chkMons.push({ key: index.toString(), value: index.toString() });
    }
  },
  methods: {
    handleClose() {
      this.$emit("closeNoticeTime");
    },
    handleSave() {
      if (this.triggerConf.rdoTimeType === "2" && !this.triggerConf.txtDay) {
        this.$message({
          type: "error",
          message: "请选择每天的时间"
        });
        return false;
      }
      if (this.triggerConf.rdoTimeType === "4") {
        if (!this.triggerConf.chkWeek) {
          this.$message({
            type: "error",
            message: "请选择每周周几"
          });
          return false;
        }
        if (!this.triggerConf.txtWeek) {
          this.$message({
            type: "error",
            message: "请选择每周时间"
          });
          return false;
        }
        if (typeof this.triggerConf.weekReminder != "number") {
          this.$message({
            type: "error",
            message: "请选择每周提醒次数"
          });
          return false;
        }
      }
      if (this.triggerConf.rdoTimeType === "5") {
        if (!this.triggerConf.chkMons) {
          this.$message({
            type: "error",
            message: "请选择每月周几"
          });
          return false;
        }
        if (!this.triggerConf.txtMon) {
          this.$message({
            type: "error",
            message: "请选择每月时间"
          });
          return false;
        }
        if (typeof this.triggerConf.monReminder != "number") {
          this.$message({
            type: "error",
            message: "请选择每月提醒次数"
          });
          return false;
        }
      }
      this.$emit("closeNoticeTime", JSON.stringify(this.triggerConf));
    }
  }
};
</script>
